import { Link, useLocation, NavLink } from "react-router-dom";
import React, { useState, useEffect} from 'react';
import { IoCloseSharp } from "react-icons/io5";
import Logo from '../assets/artistry-logo.png';
import { useTranslation } from "react-i18next";
import { IoIosMenu } from "react-icons/io";
import { FaGlobe } from "react-icons/fa";
import WhiteLogo from "../assets/whiteLogo.png"

const Header = () => {
    const [open, setOpen] = useState(false);
    const location = useLocation();
    const { i18n, t } = useTranslation();
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
      const handleScroll = () => {
        if (window.scrollY > 200) {
          setScrolled(true);
        } else {
          setScrolled(false);
        }
      };
  
      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    useEffect(() => {
    const handleScroll = () => {
      if (open) {
        setOpen(false);
      }};
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [open]);

  useEffect(() => {
    if (open) {
      setOpen(false);
    }
  }, [location]);

  const changeLanguage = () => {
    const currentLanguage = i18n.language;
    const nextLanguage = currentLanguage === "en" ? "cn" : "en";
    i18n.changeLanguage(nextLanguage);
  };


  return (
    <div className={`px-8 w-full h-20 backdrop-blur-sm fixed top-0 z-50 bg-[rgba(257,257,257,.3.5)] shadow-sm ${scrolled ? "bg-white text-black" : "bg-transparent text-white"} ${open ? "bg-white text-black" : ""}`}>

      <div className="container flex justify-between items-center h-full  mx-auto">
      <div className='flex items-center'>
        <img src={Logo } alt="Artistry spa wellness" className={`w-[150px] h-auto object-cover`}/>
      </div>
      
      <ul className="hidden md:flex space-x-8 font-poppins text-lg">

         <li className="">
            <NavLink to="/"   onClick={() => window.scrollTo(0, 0)}
            className={`transition-all font-Merriweather uppercase tracking-widest ${location.pathname === '/' ? 'border-b border-[rgb(161,121,61)] w-full' : ''}`}>
             {t('home')}
            </NavLink>
          </li>

          <li className="">
            <NavLink to="/about"   onClick={() => window.scrollTo(0, 0)}
            className={`transition-all font-Merriweather uppercase tracking-widest ${location.pathname === '/about' ? 'border-b border-[rgb(161,121,61)] w-full' : ''}`}>
             {t('about')}
            </NavLink>
          </li>

          <li className="">
            <NavLink to="/services"   onClick={() => window.scrollTo(0, 0)}
            className={`transition-all font-Merriweather uppercase tracking-widest ${location.pathname === '/services' ? 'border-b border-[rgb(161,121,61)] w-full' : ''}`}>
             {t('services')}
            </NavLink>
          </li>

          <li className="">
            <NavLink to="/priceList"   onClick={() => window.scrollTo(0, 0)}
            className={`transition-all font-Merriweather uppercase tracking-widest ${location.pathname === '/priceList' ? 'border-b border-[rgb(161,121,61)] w-full' : ''}`}>
              {t('priceList')}
            </NavLink>
          </li>


          <li className="">
            <NavLink to="/contact"   onClick={() => window.scrollTo(0, 0)}
            className={`transition-all font-Merriweather uppercase tracking-widest ${location.pathname === '/contact' ? 'border-b border-[rgb(161,121,61)] w-full' : ''}`}>
              {t('contact')}
            </NavLink>
          </li>
      </ul>

    <div className="flex justify-center items-center gap-6">
      <div className="iconBox w-6 cursor-pointer" onClick={changeLanguage}>
          <FaGlobe className="text-2xl"/>
      </div>

      {/* Mobile Menu Toggle */}
      <div className='text-4xl cursor-pointer md:hidden z-20' onClick={() => setOpen(!open)}>
        {open ? <IoCloseSharp color="black"/> : <IoIosMenu />}
      </div>
      </div>
   </div>

      {/* Mobile Menu */}
      <div className={`fixed top-0 left-0 w-full h-screen bg-white transform ${open ? 'translate-x-0' : '-translate-x-full'} transition-transform duration-300 md:hidden z-10`}>
        <ul className={`flex flex-col items-center justify-center h-full space-y-8 ${scrolled ? 'text-black' : 'text-black'}`}>
        <li className="">
            <NavLink to="/"   onClick={() => window.scrollTo(0, 0)}
            className={`transition-all font-Merriweather uppercase tracking-widest ${location.pathname === '/' ? 'border-b border-[rgb(161,121,61)] w-full' : ''}`}>
             {t('home')}
            </NavLink>
          </li>

          <li className="">
            <NavLink to="/about"   onClick={() => window.scrollTo(0, 0)}
            className={`transition-all font-Merriweather uppercase tracking-widest ${location.pathname === '/about' ? 'border-b border-[rgb(161,121,61)] w-full' : ''}`}>
             {t('about')}
            </NavLink>
          </li>

          <li className="">
            <NavLink to="/services"   onClick={() => window.scrollTo(0, 0)}
            className={`transition-all font-Merriweather uppercase tracking-widest ${location.pathname === '/services' ? 'border-b border-[rgb(161,121,61)] w-full' : ''}`}>
             {t('services')}
            </NavLink>
          </li>

          
          <li className="">
            <NavLink to="/priceList"   onClick={() => window.scrollTo(0, 0)}
            className={`transition-all font-Merriweather uppercase tracking-widest ${location.pathname === '/priceList' ? 'border-b border-[rgb(161,121,61)] w-full' : ''}`}>
              {t('priceList')}
            </NavLink>
          </li>


          <li className="">
            <NavLink to="/contact"   onClick={() => window.scrollTo(0, 0)}
            className={`transition-all font-Merriweather uppercase tracking-widest ${location.pathname === '/contact' ? 'border-b border-[rgb(161,121,61)] w-full' : ''}`}>
              {t('contact')}
            </NavLink>
          </li>

        </ul>
      </div>
    </div>
  );
};

export default Header;